import React, { useEffect, useState } from 'react'
import Helmet from 'react-helmet'
import Layout from '../components/layouts/layout';
import RiskTest from './riskTest';
import { GTMEvents } from '../lib/GTMevents';
import { PrincipalSlider, AgencyCarousel, RapidEstimatorForm, Products, Benefits } from '../components/home-public-zone';
import s from "./index.module.css";
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';

export default () => {
  /* PERFIL DE RIESGO */
  const [circleSteps, setCircleSteps] = useState(
    [
      {
        code: "QUESTION_1",
        current: true,
        active: false,
      },
      {
        code: "QUESTION_2",
        current: false,
        active: false,
      },
      {
        code: "QUESTION_3",
        current: false,
        active: false,
      },
      {
        code: "QUESTION_4",
        current: false,
        active: false,
      },
      {
        code: "QUESTION_5",
        current: false,
        active: false,
      },
      {
        code: "QUESTION_6",
        current: false,
        active: false,
      },
      {
        code: "QUESTION_7",
        current: false,
        active: false,
      }
    ])

  const openAccountRedirect = () => {
    window.open("https://miespacio.prima.com.pe/bienvenido", 'security', 'noopener');
  }
  /* FIN PERFIL DE RIESGO */

  const [getfloatElement, setGetFloatElement] = useState(false)

  useEffect(() => {
    const checkElement = setInterval(() => {
        const floatElement = document.getElementById('zsiq_float');
        if (floatElement) {
            setGetFloatElement(true)
            // Aquí asumimos que GTMEvents.ChatBotBtnAccess es una función previamente definida
            floatElement.addEventListener('click', ()=>GTMEvents.ChatBotBtnAccess('abrir'));
            // Limpieza: quitar el event listener al desmontar el componente
            // También limpiar el intervalo una vez que el elemento ha sido encontrado y el event listener ha sido añadido
            clearInterval(checkElement);
            return () => {
                floatElement.removeEventListener('click', ()=> GTMEvents.ChatBotBtnAccess('abrir'));
            };
        } else {
          console.log('');
        }
    }, 1000); // Revisar cada 1000 milisegundos (1 segundo)

    // Limpieza: asegurarse de limpiar el intervalo si el componente se desmonta antes de encontrar el elemento
    return () => clearInterval(checkElement);
  }, []);

  useEffect(() => {
    const intervalId = setInterval(() => {
      // Asumiendo que conoces el ID del iframe o alguna manera de seleccionarlo
      const iframe = document.getElementById('siqiframe');
      if (iframe) {
        // Acceso al document del iframe
        const iframeDoc = iframe.contentDocument || iframe.contentWindow.document;

        // Ahora busca el elemento dentro del iframe
        const floatElement = iframeDoc.getElementById('min_window');
        if (floatElement) {
          clearInterval(intervalId); // Detener la búsqueda

          // Definir y añadir el event listener
          const handleClick = () => GTMEvents.ChatBotBtnAccess('cerrar');
          floatElement.addEventListener('click', handleClick);

          // Función de limpieza para remover el event listener
          return () => {
            floatElement.removeEventListener('click', handleClick);
          };
        } else {
          console.log('');
        }
      }
    }, 1000); // Revisar cada 1000 milisegundos (1 segundo)

    // Limpieza: asegurarse de limpiar el intervalo si el componente se desmonta antes de encontrar el elemento
    return () => clearInterval(intervalId);
  }, []);

  return (
    <Layout>
      <Helmet>
        <link rel="canonical" href="https://www.prima.com.pe/public-zone/" />
        <script type="application/ld+json">
          {`
            {
              "@context": "https://schema.org",
              "@type": "WebSite",
              "url": "https://www.prima.com.pe/public-zone/",
              "potentialAction": {
                "@type": "SearchAction",
                "target": "https://www.prima.com.pe/public-zone/search?q={search_term_string}",
                "query-input": "search_term_string"
              }
            }
          `}
        </script>

        <script type="application/ld+json">
          {`
            {
              "@context": "https://schema.org",
              "@type": "Organization",
              "name": "Prima AFP",
              "url": "https://www.prima.com.pe/public-zone/",
              "logo": "https://www.prima.com.pe/public-zone/images/favicon.ico",
              "address": {
                "@type": "PostalAddress",
                "streetAddress": "C. Chinchón 980",
                "addressLocality": "San Isidro",
                "addressRegion": "LIMA",
                "postalCode": "15046",
                "addressCountry": "PE"
              },
              "contactPoint": {
                "@type": "ContactPoint",
                "telephone": "+01 615 7272"
              }
            }
          `}
        </script>

        <script type="application/ld+json">
          {`
            {
              "@context": "https://schema.org",
              "@type": "FinancialService",
              "name": "Prima AFP",
              "url": "https://www.prima.com.pe/public-zone/",
              "areaServed": "Peru",
              "description": "realiza consultas sobre tu estado de cuenta, cambiate a Prima AFP, aprende a ahorrar, descubre nuestros tipos de fondo y los beneficios que Prima AFP tiene para ti.",
              "acceptsPaymentMethods": [
                  "Cash",
                  "Credit Card"
              ],
              "foundingDate": "2005-03-04"
            }
          `}
        </script>

        <script type="application/ld+json">
          {`
            {
              "@context": "https://schema.org",
              "@type": "BreadcrumbList",
              "itemListElement": [
                {
                  "@type": "ListItem",
                  "position": 1,
                  "name": "Home",
                  "item": "https://www.prima.com.pe/public-zone/"
                }
              ]
            }
          `}
        </script>
      </Helmet>

      {/* NUEVO SLIDER PRINCIPAL */}
      <section className={`${s.sliderMainWrap} w-100 overflow-hidden`}>
        <PrincipalSlider />
      </section>

      {/* CAROUSEL AGENCIA */}
      <section className='tw-py-0 tw-py-0@lg bg-white border-gray-3 border-top border-bottom overflow-hidden'>
        <AgencyCarousel />
      </section>

      {/* ESTIMADOR RAPIDO */}
      <RapidEstimatorForm />

      {/* PRODUCTOS */}
      <section className='tw-py-12 tw-py-18@lg bg-white'>
        <Products />
      </section>

      {/* PERFIL DE RIESGO */}
      <section style={{ overflow: 'hidden' }}>
        <RiskTest handleButtonClick={openAccountRedirect} circleSteps={circleSteps} setCircleSteps={setCircleSteps} setClassName={'bg-gray--6'} />
      </section>

      {/* BENEFICIOS */}
      <section className='tw-py-12 tw-py-16@lg bg-white'>
        <Benefits />
      </section>
    </Layout>
  )
}

export const query = graphql`
  query {
    allHomepageJson{
      edges{
        node{
          carrousels {
            title
            description
            buttonLabel
          }
        }
      }
    }
  }
`
